import request from "@/utils/request";
import { jsonHeaders } from "./api-header-conf.js";

export function getBranchReport(params) {
  return request({
    headers: jsonHeaders,
    url: `/plan/v2/weekly/report`,
    method: "get",
    params
  });
}
